import { Star, BadgeCheck } from "lucide-react";
import Reveal from "@/components/site/Reveal";

const testimonials = [
  {
    quote:
      "Aos 47, eu achava que meu corpo tinha mudado para sempre. Em 3 semanas de Plano 40+, voltei a vestir uma calça que estava guardada há 4 anos.",
    name: "Marisa C.",
    age: "47 anos",
  },
  {
    quote:
      "Nada de dieta maluca. É um passo a passo que cabe na minha rotina de trabalho. Perdi 4,2 kg no primeiro mês — e, pela primeira vez, sem sofrimento.",
    name: "Roberto A.",
    age: "52 anos",
  },
  {
    quote:
      "O capítulo dos erros comuns, sozinho, já vale o preço. Finalmente entendi por que eu sempre desistia na segunda semana — e o que fazer diferente.",
    name: "Cláudia S.",
    age: "44 anos",
  },
];

const Testimonials = () => (
  <section id="depoimentos" data-testid="testimonials-section" className="py-24 lg:py-32">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <Reveal className="mb-16 max-w-2xl">
        <p className="eyebrow mb-5 text-accent">Quem já recomeçou</p>
        <h2 className="font-display text-3xl font-semibold leading-tight tracking-tight text-foreground sm:text-4xl lg:text-5xl">
          Histórias de quem passou dos 40{" "}
          <span className="italic text-primary">e voltou a se reconhecer.</span>
        </h2>
      </Reveal>

      <div className="grid grid-cols-1 gap-6 md:grid-cols-3 lg:gap-8">
        {testimonials.map((t, i) => (
          <Reveal key={t.name} delay={i * 0.12}>
            <figure
              data-testid={`testimonial-card-${i + 1}`}
              className="flex h-full flex-col rounded-2xl border border-border bg-card p-8 shadow-sm transition-[border-color,box-shadow,transform] duration-500 hover:-translate-y-1 hover:border-primary/40 hover:shadow-xl"
            >
              <div className="flex gap-1" aria-label="5 de 5 estrelas">
                {Array.from({ length: 5 }).map((_, s) => (
                  <Star key={s} className="h-4 w-4 fill-accent text-accent" />
                ))}
              </div>
              <blockquote className="mt-6 flex-1 font-display text-xl font-medium leading-relaxed text-foreground">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-8 flex items-center justify-between border-t border-border pt-5">
                <div>
                  <p className="font-semibold text-foreground">{t.name}</p>
                  <p className="text-sm text-muted-foreground">{t.age}</p>
                </div>
                <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary px-3 py-1 text-xs font-medium text-primary">
                  <BadgeCheck className="h-3.5 w-3.5" />
                  Compra verificada
                </span>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Testimonials;
